<template>
  <div class="box gray-box">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="24">
          <h3>优惠码</h3>
        </el-col>
      </el-row>
      <ul class="coupon-list clearfix">
        <li v-for="(item, idx) in taskInfo.coupon">
          {{item}}
          <i class="el-icon-close" @click="del(idx)"></i>
        </li>
      </ul>
      <el-input placeholder="优惠码" v-model="coupon" v-on:input="filter" >
        <el-button @click="add()" slot="append">&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
      </el-input>
      <a style="color: red;margin-top:5px;display:inline-block;" v-if="couponshow">*优惠码应为1到30位</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UseCoupon',
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  components: {
  },
  created () {
  },
  data () {
    return {
      coupon: null,
      couponshow: false
    }
  },
  methods: {
    add: function () {
      if (this.coupon) {
        if (this.coupon.length > 30) {
          this.couponshow = true
          return
        }
        this.taskInfo.coupon.push(this.coupon)
        this.couponshow = false
        this.coupon = null
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    del (idx) {
      this.taskInfo.coupon.splice(idx, 1)
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    filter () {
      this.coupon = this.coupon.replace(/\s+/g, '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.coupon-list {
  margin-bottom: 10px;

  li {
    float: left;
    margin-right: 15px;
    min-width: 114px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    background-color: #F4F4FA;
    margin-bottom: 10px;
    text-align: center;
    color: #888888;
    font-size: 12px;
    padding: 0 20px;
    position: relative;

    i {
      position: absolute;
      right: 10px;
      top: 8px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/UseCoupon.vue